import React, { useEffect, useState } from "react";
import {
  Container,
  Box,
  TextField,
  Typography,
  Paper,
  InputAdornment,
  Grid,
  Button,
} from "@mui/material";
import { AccountCircle, Home, Info } from "@mui/icons-material";
import { useSelector, useDispatch } from "react-redux";
import { profileInformation } from "../../features/Dev/devSlice";
import {
  createDevHome,
  getDevHome,
  updateDevHome,
} from "../../features/Dev/homeSlice";

const DevInfo = () => {
  const [editDevHome, setEditDevHome] = useState({
    home_welcome: "",
    home_title: "",
    home_description: "",
    about_title: "",
    about_description: "",
  });
  const { user } = useSelector((state) => state.auth);
  const { dev } = useSelector((state) => state.dev);
  const { home } = useSelector((state) => state.home);

  const { firstName, lastName, name, email, phone, photo_url } = dev;

  useEffect(() => {
    setEditDevHome({
      // ...editDevHome,
      home_welcome: home?.home_welcome !== null ? home?.home_welcome : "",
      home_title: home?.home_title !== null ? home?.home_title : "",
      home_description:
        home?.home_description !== null ? home?.home_description : "",
      about_title: home?.about_title !== null ? home?.about_title : "",
      about_description:
        home?.about_description !== null ? home?.about_description : "",
    });
  }, [home]);

  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(getDevHome());
  }, []);

  const handleDevHomeChange = (event) => {
    setEditDevHome({
      ...editDevHome,
      [event.target.name]: event.target.value,
    });
  };

  const handleDevHomeSumbit = (e) => {
    e.preventDefault();
    dispatch(updateDevHome(editDevHome));
    dispatch(getDevHome());
  };

  const handleCreateDevHomeSubmit = (e) => {
    e.preventDefault();
    dispatch(createDevHome(editDevHome));
    dispatch(getDevHome());
  };

  return (
    <>
      {/* {JSON.stringify(editDevHome)} */}
      <Container
        maxWidth="lg"
        sx={{
          justifyContent: "center",
          alignItems: "center",
          display: "flex",
          height: "100%",
          width: "100%",
        }}
      >
        <Box sx={{ minWidth: "100%" }}>
          <Paper p={1} elevation={2}>
            <Box
              sx={{ p: 2 }}
              component="form"
              onSubmit={
                home?.id !== null
                  ? handleDevHomeSumbit
                  : handleCreateDevHomeSubmit
              }
            >
              <Box>
                <Typography variant="h5" sx={{ textAlign: "center" }}>
                  Edit Home Page
                </Typography>
              </Box>

              <Grid container spacing={2}>
                <Grid item xs={12} sm={6}>
                  <Box
                    sx={{
                      borderRadius: "20px",
                    }}
                  >
                    <Grid container direction="column" spacing={2}>
                      <Grid item xs={12}>
                        <Box p={2}>
                          <Typography variant="h6">
                            Home Informations
                          </Typography>
                        </Box>
                        <Box sx={{ display: "flex", alignItems: "flex-end" }}>
                          <Home
                            sx={{ color: "action.active", mr: 1, my: 0.5 }}
                          />
                          <TextField
                            id="input-with-sx"
                            label="home welcome text"
                            variant="standard"
                            fullWidth
                            placeholder="Enter a welcome text"
                            name="home_welcome"
                            onChange={handleDevHomeChange}
                            multiline
                            rows={2}
                            type="text"
                            value={editDevHome?.home_welcome}
                            required
                            helperText={
                              editDevHome?.id == null ? "empty" : "oiuytg"
                            }
                          />
                        </Box>
                      </Grid>
                      <Grid item xs={12} sm={6}>
                        <Box sx={{ display: "flex", alignItems: "flex-end" }}>
                          <Home
                            sx={{ color: "action.active", mr: 1, my: 0.5 }}
                          />
                          <TextField
                            id="input-with-sx"
                            label="home title"
                            variant="standard"
                            placeholder="Enter a title"
                            fullWidth
                            name="home_title"
                            onChange={handleDevHomeChange}
                            type="text"
                            value={editDevHome.home_title}
                            required
                            multiline
                            rows={3}
                          />
                        </Box>
                      </Grid>
                      <Grid item xs={12} sm={6}>
                        <Box sx={{ display: "flex", alignItems: "flex-end" }}>
                          <Home
                            sx={{ color: "action.active", mr: 1, my: 0.5 }}
                          />
                          <TextField
                            id="input-with-sx"
                            label="home description"
                            variant="standard"
                            placeholder="Enter at least one paragraph"
                            fullWidth
                            name="home_description"
                            onChange={handleDevHomeChange}
                            type="text"
                            value={editDevHome.home_description}
                            required
                            multiline
                            rows={4}
                          />
                        </Box>
                      </Grid>
                    </Grid>
                  </Box>
                </Grid>
                <Grid item xs={12} sm={6}>
                  <Box>
                    <Grid container direction="column" spacing={2}>
                      <Grid item xs={12}>
                        <Box p={2}>
                          <Typography variant="h6">
                            About Informations
                          </Typography>
                        </Box>
                        <Box sx={{ display: "flex", alignItems: "flex-end" }}>
                          <Info
                            sx={{ color: "action.active", mr: 1, my: 0.5 }}
                          />
                          <TextField
                            id="input-with-sx"
                            label="about title"
                            variant="standard"
                            fullWidth
                            placeholder="Enter a title"
                            name="about_title"
                            onChange={handleDevHomeChange}
                            multiline
                            rows={3}
                            type="text"
                            value={editDevHome.about_title}
                            required
                          />
                        </Box>
                      </Grid>
                      <Grid item xs={12} sm={6}>
                        <Box sx={{ display: "flex", alignItems: "flex-end" }}>
                          <Info
                            sx={{ color: "action.active", mr: 1, my: 0.5 }}
                          />
                          <TextField
                            id="input-with-sx"
                            label="about description"
                            variant="standard"
                            placeholder="Enter at least one paragraph"
                            fullWidth
                            name="about_description"
                            onChange={handleDevHomeChange}
                            type="text"
                            value={editDevHome.about_description}
                            multiline
                            rows={4}
                            required
                          />
                        </Box>
                      </Grid>
                    </Grid>
                  </Box>
                </Grid>
              </Grid>

              <Box sx={{ display: "flex", justifyContent: "center" }} p={3}>
                {/* {console.log(home?.id)} */}
                {home?.id === null ? (
                  <Button variant="outlined" size="large" type="submit">
                    create Home
                  </Button>
                ) : (
                  <Button variant="outlined" size="large" type="submit">
                    Update Home
                  </Button>
                )}
              </Box>
            </Box>
          </Paper>
        </Box>
      </Container>
    </>
  );
};

export default DevInfo;
